import { actions as segmentioActions } from '@saucelabs/sl-util-segmentio';

export const NAVIGATION_EVENTS = Object.freeze({
  CLICK_LOGOUT: 'nav/click/logout',
  CLICK_USAGE_CONCURRENCY_REAL: 'nav/visit/usage__concurrent-sessions__real',
  CLICK_USAGE_CONCURRENCY_VIRTUAL: 'nav/visit/usage__concurrent-sessions__virtual',
  CLICK_USAGE_REMAINING_AUTOMATED: 'nav/visit/usage__remaining-time__automated',
  LOGO_VISIT_DASHBOARD: 'nav/visit/home',
  OBJECT_CLICKED: 'Object Clicked',
  SWITCH_DC: 'nav/click/switch-dc',
  TOGGLE_ANALYTICS: 'nav/toggle/analytics',
  TOGGLE_AUTOMATED: 'nav/toggle/automated',
  TOGGLE_LABS: 'nav/toggle/labs',
  TOGGLE_MANUAL: 'nav/toggle/manual',
  TOGGLE_SAUCE_APPS: 'nav/toggle/sauce-apps',
  TOGGLE_USAGE: 'nav/toggle/usage',
  VISIT_ANALYTICS_FAILURE_ANALYSIS: 'nav/visit/analytics__failure-analysis',
  VISIT_ANALYTICS_TEST_ERRORS: 'nav/visit/analytics__test-errors',
  VISIT_ANALYTICS_TEST_HISTORY: 'nav/visit/analytics__test-history',
  VISIT_ANALYTICS_TEST_OVERVIEW: 'nav/visit/analytics__test-overview',
  VISIT_ANALYTICS_TRENDS: 'nav/visit/analytics__trends',
  VISIT_ANALYTICS_VM_CONCURRENCY: 'nav/visit/analytics__vm-concurrency',
  VISIT_ANALYTICS_COVERAGE: 'nav/visit/analytics__coverage',
  VISIT_AUTOMATED_BUILDS: 'nav/visit/automated__builds',
  VISIT_AUTOMATED_TESTS: 'nav/visit/automated__test-results',
  VISIT_BILLING: 'nav/visit/billing',
  VISIT_DOCUMENTATION: 'nav/visit/documentation',
  VISIT_GETTING_STARTED: 'nav/visit/getting-started',
  VISIT_INTEGRATIONS: 'nav/visit/integrations',
  VISIT_LABS_SECURITY: 'nav/visit/labs__security',
  VISIT_MANUAL_APP_TESTING: 'nav/visit/manual__mobile-app',
  VISIT_MANUAL_BROWSER_TESTING: 'nav/visit/manual__cross-browser',
  VISIT_MANUAL_TEST_RESULTS: 'nav/visit/manual__test-results',
  VISIT_RDC_LANDING_PAGE: 'nav/visit/real-devices__landing-page',
  VISIT_SAUCE_APPS_RDC: 'nav/visit/sauce-apps__legacy-rdc',
  VISIT_SAUCE_APPS_VISUAL: 'nav/visit/sauce-apps__visual',
  VISIT_STATUS_PAGE: 'nav/visit/status-page',
  VISIT_SUPPORT_PORTAL: 'nav/visit/support',
  VISIT_TEAM_MANAGEMENT: 'nav/visit/team-management',
  VISIT_TESTFAIRY: 'nav/visit/testfairy',
  VISIT_TESTFAIRY_V2: 'Navigation/Visit TestFairy',
  VISIT_TUNNELS: 'nav/visit/tunnels',
  VISIT_USER_SETTINGS: 'nav/visit/user-settings',
  VISIT_LAB: 'nav/visit/lab',
});

export const PRODUCT_AREA = 'Growth';
export const PRODUCT_SUB_AREA = 'Navigation Sidebar';

export const SUBJECT = Object.freeze({
  SHOW_API_TESTING: 'Show modal for API Testing',
  HIDE_API_TESTING: 'Hide modal for API Testing',
  SHOW_MOBILE_TESTING: 'Show modal for Mobile Beta Testing',
  HIDE_MOBILE_TESTING: 'Hide modal for Mobile Beta Testing',
});

export const API_TESTING_NAVIGATION_ATTRIBUTES = Object.freeze({
  page: 'Navigation bar',
  product_area: 'API Testing',
  product_sub_area: 'General',
  subject_name: 'Navigate to API Testing',
});

export const BANNER_EVENTS = Object.freeze({
  BANNER_PAYMENT_FAILED_DISPLAYED: 'banner/payment-failed/displayed',
  BANNER_PAYMENT_FAILED_CLICK: 'banner/payment-failed/click',
  BANNER_PAYMENT_FAILED_MAILTO_SUPPORT: 'banner/payment-failed/mailto-support',
});

export const ORG_ROLES = Object.freeze({
  ORG_ADMIN: 'org_admin',
  TEAM_ADMIN: 'team_admin',
  NON_ADMIN: 'non_admin',
});

export const STATE_CLOSED = 'closed';
export const STATE_OPEN = 'open';
export const V2_VERSION = '2.0';

export const ONE_CLICK_BILLING_PLAN = Object.freeze({
  MANUAL: 'Manual',
  AUTOMATED: 'Automated',
});

export const ONE_CLICK_BILLING_BUTTON = Object.freeze({
  ADD_PLAN: 'Add plan',
  UPGRADE_NOW: 'Upgrade now',
  EDIT_ORDER: 'Edit order',
  VIEW_EXPIRY: 'View expiry',
  CONTACT_FOR_ENTERPRISE: 'Contact for enterprise',
});

export const EVENTS = {
  MAIN_NAV_ADD_PLAN_CTA: 'Main Navigation - Add plan',
  OBJECT_CLICKED: 'Object Clicked',
};

export const trackStandardEvent = ({ plan, subjectName, daysLeft, interval }) => (
  segmentioActions.recordTrack(EVENTS.OBJECT_CLICKED, {
    plan,
    days_left: daysLeft,
    subject_name: subjectName,
    interval,
    product_area: 'Growth',
    product_sub_area: 'Upgrade CTA',
    domain: 'app.saucelabs.com',
    page: 'Navigation bar',
  })
);

export const trackEvent = segmentioActions.recordTrack;
export default trackEvent;
